import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Delete from "../../components/delete/Delete";
import VideoPlayer from "../../components/videoplayer/VideoPlayer";
import Select from "../../components/select/Select";
import MultiSelect from "../../components/multiselect/MultiSelect";
import "../programsdetails/ProgramsDetails.css";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import LoadingButtonText from "../../components/loadingButtonText/loadingButtonText";

const WorkoutDetails = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [workoutName, setWorkoutName] = useState("");
  const [errorInputs, setErrorInputs] = useState(false);
  const [workoutLevel, setWorkoutLevel] = useState("");
  const [activityPool, setActivityPool] = useState([]);
  const [workoutDesc, setWorkoutDesc] = useState("");
  // eslint-disable-next-line
  const [workoutRom, setWorkoutRom] = useState("0%");
  const [workoutTemplateId, setWorkoutTemplateId] = useState("");
  const [workoutDuration, setWorkoutDuration] = useState("");
  const [pTLoading, setPTLoading] = useState(id ? true : false);
  const [submitting, setSubmitting] = useState(false);
  const percentageArr = Array.from({ length: 7 }, (_, index) => ({
    value: `${40 + index * 10}%`,
  }));
  const [maxRom] = useState(percentageArr);
  
  const setMaxMinROM = (lowest) => {
	  var retArray = [];
	  for ( var i = lowest; i <= 100; i += 10 ) {
		  retArray.push({value: i+'%'});
	  }
	  return retArray;
  };
  
  const setLimb = (limbs) => {
    var retArray = [];
    limbs.forEach((itm) => {
		retArray.push({ value: itm.name });
	});
    return retArray;
  };

  const [exerciseCollection, setExerciseCollection] = useState([]);
  const handleExrSelection = (inx) => {
    var exrs = [...exerciseCollection];
    exrs[inx].checked = !exrs[inx].checked;
    addExrToOrder(exrs[inx], exrs[inx].checked, inx);
    setExerciseCollection(exrs);
  };

  const [exrOrdered, setExrOrdered] = useState([]);

  const addExrToOrder = (obj, add, inxIdent) => {
    var eOrder = [...exrOrdered];
    if (add) {
      obj.inxIdent = inxIdent;
      eOrder.push(obj);
    } else {
      var remInx = 0;
      for (var exr of eOrder) {
        if (exr.inxIdent === inxIdent) {
          eOrder.splice(remInx, 1);
        }
        remInx++;
      }
    }

    setExrOrdered(eOrder);
  };

  const validateInput = (input) => {
    const regex = /^[a-zA-Z0-9 .,?!]*$/;
    return regex.test(input);
  };

  const updateWorkoutsData = (paramToChange, value) => {
    const valid = validateInput(value);
    if (!valid) {
      setErrorPopUp("Invalid input: only letters, numbers, spaces, and standard punctuation are allowed.");
      return;
    }

    if (paramToChange === "workout_name") {
      setWorkoutName(value);
    }

    if (paramToChange === "workout_desc") {
      setWorkoutDesc(value);
    }
  }
  const [isOpenVideo, setOpenVideo] = useState(false);
  const [previewItem, setPreviewItem] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const openCloseVideo = (item, title) => {
    setOpenVideo(!isOpenVideo);
    setPreviewItem(item);
    setPreviewTitle(title);
  };

  useEffect(() => {
    if (id && workoutTemplateId) {
      var task_id = workoutTemplateId;
      props.actSidebar(false);
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        setPTLoading(true)
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_programs/task-activities", { task_id })
          .then((res) => {
            if (res.data.responseData) {
              let response = res.data.responseData;
              setWorkoutName(response.name);
              setWorkoutDesc(response.description);
              setWorkoutLevel(response.level);
              setWorkoutDuration(response.duration);
              setActivityPool(response.activity_data || []);

              setExrPage(document.getElementById("exr_bld"));
              setPTLoading(false)
            }
          })
          .catch((error) => {
            console.error(error);
            setPTLoading(false)
            if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
              props.checkLoggedIn(false);
            }
          })
      }
    }
    // eslint-disable-next-line
  }, [props, workoutTemplateId]);

  /* useEffect(() => {
    props.actSidebar(false);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/get_all_activities")
        .then((res) => {
          if (res.data.responseData) {
            let response = res.data.responseData;
            console.log("zzzzzzzzzzzzzz", response);

            setActivityPool(response);
            console.log(activityPool);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          }
        });
    }
  }, [props, workoutTemplateId]); */

  const [eqIds, setEqIds] = useState([]);

  useEffect(() => {
    var exers = [];

    for (var exerc of exerciseCollection) {
      if (exerc.exercise_data.hold_in_seconds === 0) {
        exers.push(exerc.exercise_data.equipment_id);
      }
      setEqIds(exers); //exercise ids that has 0 hold in sec
    }
  }, [exerciseCollection]);

  const numericOptsHold = (valNum, sym) => {
    let valArr = [];
    var noHold = { value: "No Hold" };
    valArr.push(noHold);
    var i = 1;
    if (sym === "%") {
      i = 0;
    }

    for (i; i <= valNum; i++) {
      var valObj = { value: i + (sym ? sym : "") };
      valArr.push(valObj);
    }
    return valArr;
  };

  const numericOptsDuration = (valNum, sym) => {
    let valArr = [];
    var i = 1;
    if (sym === "%") {
      i = 0;
    }

    for (i; i <= valNum; i++) {
      var valObj = { value: i + (sym ? sym : "") };
      valArr.push(valObj);
    }
    return valArr;
  };

  const exrMove = (inx, upOrDn) => {
    let targetPlace = [...activityPool];
    if (inx + upOrDn === -1 || inx + upOrDn === targetPlace.length) {
      return false;
    }
    let newObj = { ...targetPlace[inx] };
    let tempId = newObj.act_id;
    let newObj2 = { ...targetPlace[inx + upOrDn] };

    newObj.act_id = newObj2.act_id;
    newObj2.act_id = tempId;
    targetPlace[inx] = newObj2;
    targetPlace[inx + upOrDn] = newObj;
    setActivityPool(targetPlace);
  };

  const exrDuplicate = (inx) => {
    let sumReps = 0;
    let sumTime = 0;
    let targetPlace = [...activityPool];
    let newObj = { ...targetPlace[inx] };
    delete newObj.act_id;
    targetPlace.push(newObj);
    setActivityPool(targetPlace);

    for (var oneTime of targetPlace) {
      sumReps += oneTime.reps;
      if (oneTime.hold_in_seconds > 0) {
        sumTime = sumReps * (oneTime.hold_in_seconds + 5);
      } else {
        sumTime = sumReps * 5;
      }
    }

    setWorkoutDuration(Math.ceil(sumTime / 60));
  };

  const [arrToDelete, setArrToDelete] = useState(-1);
  const [isOpenDelete, setOpenDelete] = useState(false);

  const openCloseDelete = (item) => {
    setOpenDelete(!isOpenDelete);
    setArrToDelete(item);
  };

  const [optionsPlainNumsReps] = useState(numericOptsDuration(30));
  const [optionsPlainNums] = useState(numericOptsHold(60));

  /* const [taskLevels] = useState([
    { value: "Beginner" },
    { value: "Basic" },
    { value: "Pre-Intermediate" },
    { value: "Intermediate" },
    { value: "Intermediate-High" },
    { value: "Advanced" },
  ]); */

  const [exrPage, setExrPage] = useState({});
  const [wrapMarg] = useState(10);

  const updateActDets = (valueSet, value) => {
    let sumReps = 0;
    let sumTime = 0;
    if (value === "No Hold") {
      value = "0";
    }
    var actArr = [...activityPool];
    if (!isNaN(value)) {
      value = parseInt(value);
    }
    actArr[valueSet[0]][valueSet[1]] = value;
    for (var oneTime of actArr) {
      sumReps += oneTime.reps;
      if (oneTime.hold_in_seconds > 0) {
        sumTime = sumReps * (oneTime.hold_in_seconds + 5);
      } else {
        sumTime = sumReps * 5;
      }
    }
    setWorkoutDuration(Math.ceil(sumTime / 60));
    setActivityPool(actArr);
  };

  const [exrCollectionOpen, setExrCollectionOpen] = useState(false);
  const openUpExrCollection = () => {
    setExrCollectionOpen(true);
  };

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 6000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  // eslint-disable-next-line
  const updateWorkoutLevel = (callVal, value) => {
    callVal(value);
  };

  const [collectSearch, setCollectSearch] = useState("");
  const searchExr = useRef("");
  const updateCollectSearch = (value) => {
    setCollectSearch(value.trim());
  };

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_programs/get-exercise-templates", {
        search: "",
        exerciseData: exerciseCollection.filter((item) => item.checked === true),
      })
      .then((res) => {
        if (res.data.responseData) {
          let response = res.data.responseData.exerciseData;
          const sort = response.sort((a, b) => a.is_portrait - b.is_portrait);

          sort.sort((a, b) => {
            if (b.is_portrait > a.is_portrait) {
              return -1;
            } else if (b.is_portrait < a.is_portrait) {
              return 1;
            } else {
              return a.name.localeCompare(b.name);
            }
          });
          setExerciseCollection(response);
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, [exrCollectionOpen]);

  const dltDismiss = (doConfirm) => {
    if (doConfirm) {
      let sumReps = 0;
      let sumTime = 0;
      let targetPlace = [...activityPool];
      var activity_id = targetPlace[arrToDelete].act_id;
      targetPlace.splice(arrToDelete, 1);

      for (var oneTime of targetPlace) {
        sumReps += oneTime.reps;
        if (oneTime.hold_in_seconds > 0) {
          sumTime = sumReps * (oneTime.hold_in_seconds + 5);
        } else {
          sumTime = sumReps * 5;
        }
      }

      setWorkoutDuration(Math.ceil(sumTime / 60));
      setActivityPool(targetPlace);

      if (activity_id) {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_programs/delete-activity", {
            activity_id,
          })
          .then(() => {
            var deletedActArr = [];
            if (localStorage.getItem("deleted_activities") !== null) {
              deletedActArr = JSON.parse(localStorage.getItem("deleted_activities"));
            }
            deletedActArr.push(activity_id);
            localStorage.setItem("deleted_activities", JSON.stringify(deletedActArr));
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
    setOpenDelete(false);
    setArrToDelete(-1);
  };

  useEffect(() => {
    props.actSidebar(false);
    var userData = JSON.parse(localStorage.getItem("userData"));
    var work_templId = JSON.parse(localStorage.getItem("workout_templateId"))
      ? JSON.parse(localStorage.getItem("workout_templateId"))
      : 0;
    setWorkoutTemplateId(work_templId);
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
    }
  }, [props]);

  const [disablePortreit, setDisablePortreit] = useState(false);
  const [disableLandscape, setDisableLandscape] = useState(false);

  useEffect(() => {
    if ((disablePortreit || disableLandscape) && exrCollectionOpen) {
      setErrorPopUp(
        "For an optimal patient experience Virdio Health, requires your PT session includes all Floor exercises  than Standing or Sitting exercises, or vice versa."
      );
    }
  }, [disablePortreit, disableLandscape, exrCollectionOpen]);

  useEffect(() => {
    if (activityPool?.length < 1) {
      if (exrOrdered?.length > 1) {
        let isInArrPortreit = exrOrdered.some((obj) => obj.is_portrait === 1);
        let isInArrLandscape = exrOrdered.some((obj) => obj.is_portrait === 0);

        if (exrOrdered[0]?.is_portrait === 1 && isInArrLandscape === true) {
          setDisablePortreit(true);
        } else if (exrOrdered[0]?.is_portrait === 0 && isInArrPortreit === true) {
          setDisableLandscape(true);
        } else if (exrOrdered[0]?.is_portrait === 1 && isInArrLandscape === false) {
          setDisablePortreit(false);
          setDisableLandscape(false);
        } else if (exrOrdered[0]?.is_portrait === 0 && isInArrPortreit === false) {
          setDisableLandscape(false);
          setDisablePortreit(false);
        }
      } else {
        setDisablePortreit(false);
        setDisableLandscape(false);
      }
    } else {
      let isInPoolPortreit = activityPool.some((obj) => obj.is_portrait === 1);
      let isInPoolLandscape = activityPool.some((obj) => obj.is_portrait === 0);

      let isInOrderedPortreit = exrOrdered.some((obj) => obj.is_portrait === 1);
      let isInOrderedLandscape = exrOrdered.some((obj) => obj.is_portrait === 0);

      if (activityPool?.length >= 1) {
        if (activityPool[0]?.is_portrait === 1 && isInPoolLandscape === true) {
          setDisablePortreit(true);
          setDisableLandscape(false);
        } else if (activityPool[0]?.is_portrait === 0 && isInPoolPortreit === true) {
          setDisableLandscape(true);
        } else if (activityPool[0]?.is_portrait === 1 && isInPoolLandscape === false) {
          setDisablePortreit(false);
          setDisableLandscape(false);

          if (isInOrderedLandscape) {
            setDisablePortreit(true);
          }
        } else if (activityPool[0]?.is_portrait === 0 && isInPoolPortreit === false) {
          setDisableLandscape(false);
          setDisablePortreit(false);

          if (isInOrderedPortreit) {
            setDisableLandscape(true);
          }
        }
      } else {
        setDisablePortreit(false);
        setDisableLandscape(false);
      }
    }
  }, [activityPool, exrOrdered]);

  const saveEditChanges = () => {
    setErrorPopUp("");
    setErrorInputs(false);
    if (!workoutName || workoutName.trim() === "") {
      setErrorPopUp("Please fill in all the marked fields.");
      setErrorInputs(true);
      return false;
    } else if (workoutName.trim().length < 3) {
      setErrorPopUp("PT Session Name must be at least 3 characters long.");
      setErrorInputs(true);
      return false;
    }

    if (workoutName === "New PT Session") {
      setErrorPopUp("Invalid PT session name, try different name.");
      setErrorInputs(true);
      return false;
    }

    if (activityPool && activityPool.length === 0) {
      setErrorPopUp("Please add at least one Exercise.");
      return false;
    }
    for (var singleActivity of activityPool) {
      if (!singleActivity.equipment_name || !singleActivity.display_name || !singleActivity.reps) {
        setErrorPopUp("Please fill in all the marked fields.");
        setErrorInputs(true);
        return false;
      }
    }

    if (location.pathname === "/newworkout/" + workoutTemplateId) {
      var task_id = workoutTemplateId;
      setSubmitting(true);
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/update-workout-template", {
          task_id,
          workoutName,
          workoutDesc,
          workoutLevel,
          workoutRom,
          workoutDuration,
          activityPool,
        })
        .then((res) => {
          if (res.data.responseData) {
            let response = res.data.responseData;
            if (response.activities || response.message === "success") {
              localStorage.setItem("updateWorkouts", true);
              navigate("/workouts");
            }
          }
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => {
          setSubmitting(false);
        });
    } else {
      setSubmitting(true);
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/save-workout-template", {
          workoutName,
          workoutDesc,
          workoutLevel,
          workoutRom,
          workoutDuration,
          activityPool,
        })
        .then((res) => {
          if (res.data.responseData) {
            let response = res.data.responseData;
            if (response.activities || response.message === "success") {
              navigate("/workouts");
            }
          }
        })
        .catch((error) => {
          if (error.response.data.responseCode === 417) {
            setErrorPopUp("PT Session with the same name already exists.");
            setErrorInputs(true);
          }
          console.error(error);
        }).finally(() => {
          setSubmitting(false);
        });;
    }
  };

  //const [isExitOpen, setExitOpen] = useState(false);
  /* const handleExit = (confirmSave) => {
    if (!workoutLevel && !workoutDesc && !workoutDuration && activityPool.length === 0) {
      navigate(
        task_id
          ? "/details/" + sendBackParam + "/edit"
          : "/" + (localStorage.getItem("prev_link") ? localStorage.getItem("prev_link") : "newprogram")
      );
    }

    if (
      workoutName !== workoutNameCopy ||
      workoutDesc !== workoutDescCopy ||
      workoutLevel !== workoutLevelCopy ||
      workoutRom !== workoutRomCopy ||
      workoutDuration !== workoutDurationCopy ||
      JSON.stringify(activityPool) !== activityPoolCopy
    ) {
      setExitOpen(!isExitOpen);
    } else {
      navigate(
        task_id
          ? "/details/" + sendBackParam + "/edit"
          : "/" + (localStorage.getItem("prev_link") ? localStorage.getItem("prev_link") : "newprogram")
      );
    }

    if (confirmSave) {
      saveEditChanges();
    }
  }; */

  const handleFilters = (arrayOfFilters, selectedOption) => {
    var arrData = [];
    for (var option of arrayOfFilters) {
      arrData.push(option.value);
    }
    selectedOption(arrData);
  };

  const [subProblemFilter, setSubProblemFilter] = useState(["Show All"]);
  const [typeFilter, setTypeFilter] = useState(["Show All"]);
  const [difficultyFilter, setDifficultyFilter] = useState(["Show All"]);
  const [levelFilter, setLevelFilter] = useState(["Show All"]);

  const countChildren = useRef(null);
  const [shownChildren, setShownChildren] = useState(null);

  useEffect(() => {
    if (countChildren.current !== null) {
      var shown = 0;
      for (var child of countChildren.current.childNodes) {
        if (
          child.classList.value.split(" ")[1] !== "exr_coll_hidden" &&
          child.classList.value !== "exr_empty" &&
          child.classList.value !== "exr_card_desc"
        ) {
          shown++;
        }
      }
      setShownChildren(shown);
    }
  }, [subProblemFilter, typeFilter, difficultyFilter, levelFilter, exerciseCollection, collectSearch]);

  const addOrRemoveSets = (inx, mod) => {
    var exrs = [...exerciseCollection];
    if (mod === "add") {
      exrs[inx].multiple_sets++;
    } else if (mod === "substract" && exrs[inx].multiple_sets - 1 > 0) {
      exrs[inx].multiple_sets--;
    }
    setExerciseCollection(exrs);
  };

  const addDismiss = (isSave) => {
    if (isSave) {
      insertNewActs();
    }
    var exrs = [...exerciseCollection];
    for (var exr of exrs) {
      exr.checked = false;
    }
    setSubProblemFilter(["Show All"]);
    setTypeFilter(["Show All"]);
    setDifficultyFilter(["Show All"]);
    setLevelFilter(["Show All"]);
    setCollectSearch("");

    setExerciseCollection(exrs);
    setExrCollectionOpen(false);
    setExrOrdered([]);

    if (activityPool?.length < 1) {
      setDisablePortreit(false);
      setDisableLandscape(false);
    }
  };

  const insertNewActs = () => {
    let sumReps = 0;
    let sumTime = 0;
    var actArr = [...activityPool];
    for (var exercise of exrOrdered) {
      for (var i = 0; i < exercise.multiple_sets; i++) {
        actArr.push({
          equipment_id: exercise.exercise_data.equipment_id,
          equipment_name: exercise.exercise_data.equipment_name,
          display_name: exercise.exercise_data.display_name,
          reps: exercise.exercise_data.reps,
          hold_in_seconds: exercise.exercise_data.hold_in_seconds,
          duration_type: exercise.exercise_data.duration_type,
          duration: exercise.exercise_data.duration,
          video: exercise.exercise_data.video,
          image: exercise.exercise_data.image,
          is_portrait: exercise.is_portrait,
          have_rom: exercise.have_rom,
          rom_minimum: exercise.rom_minimum,
          target_rom_max: "100%",
          set_limb_instruction: '',
          is_complete: 0,
        });
      }
    }

    for (var exr of exerciseCollection) {
      exr.checked = false;
    }

    for (var oneTime of actArr) {
      sumReps += oneTime.reps;
      if (oneTime.hold_in_seconds > 0) {
        sumTime = sumReps * (oneTime.hold_in_seconds + 5);
      } else {
        sumTime = sumReps * 5;
      }
    }

    setWorkoutDuration(Math.ceil(sumTime / 60));

    setExrOrdered([]);
    setActivityPool(actArr);
  };

  return (
    <div className="prog_dets_full_wrap" id="exr_bld">
      <Breadcrumbs workoutId={workoutTemplateId} workoutName={workoutName}></Breadcrumbs>
      <div className="prog_dets_title_and_btn_holder" >
        <div className="new_workout_title_and_btn_holder"  style={{display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap'}}>
          <div className="new_workout_title" style={{flex: 1}}>
            {location.pathname === "/newworkout/" + workoutTemplateId ? "Edit PT Session" : "New PT Session"}
          </div>
          <div style={{display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center'}}>
          {location.pathname === "/newworkout/" + workoutTemplateId && 
          <div className="prog_edit_btn prog_edit_invert prog_det_new_btn_left" onClick={() => 
            navigate("/workouts")
          }>
            Cancel
          </div>
          }
          <button disabled={submitting || pTLoading} style={{ float: "right" }} className="prog_edit_btn prog_save_btn" onClick={() => saveEditChanges()}>
            {location.pathname === "/newworkout/" + workoutTemplateId ? 
            <LoadingButtonText loading={submitting} text={"Save Edits"} loadingText={"Saving Edits"} />
            : 
            <LoadingButtonText loading={submitting} text={"Save PT Session"} loadingText={"Saving PT Session"} />
            }
          </button>
          </div>
        </div>
      </div>
      {
        pTLoading
        ?
        <div className="loader_full_container">
          <div className="p_load mess_p_load"></div>
        </div>
        :
        <>
      <div className="prog_det_top_hold builder_row_container">
        <div className="e_build_main_title" style={{flex: 1}}>
          <div
            className={
              "eb_main_input_hold" +
              (errorInputs && (!workoutName || workoutName === "New PT Session") ? " prog_err_input" : "")
            }
          >
            <div style={{height: "100%"}} className={workoutName && workoutName.length > 0 ? "select_main h-full overflow-hidden" : "select_main select_active_length h-full overflow-hidden"}>
              {workoutName && workoutName.length > 0 && (
                <div className="select_placeholder sp_act">PT Session Name (Max 30 Characters)</div>
              )}
              <div>
                <input
                  className="select_main_name"
                  type="text"
                  maxLength={30}
                  value={workoutName}
                  placeholder={"PT Session Name"}
                  onChange={(e) => updateWorkoutsData("workout_name", e.target.value)}
                />
              </div>
            </div>
          </div>
          {/* <div className="eb_upper_selects">
            <div className="eb_main_select_hold eb_select_lvl">
              <Select
                initVal={workoutLevel}
                placeholder={"Level"}
                selectOptions={taskLevels}
                callBackValue={setWorkoutLevel}
                selectCallback={updateWorkoutLevel}
                selectError={!workoutLevel && errorInputs}
                inExerciseBuild={true}
              />
            </div>
          </div> */}
        </div>
        <div className="e_build_description">
          <div className="eb_main_input_hold eb_input_large">
            <div style={{height: "100%"}}  className="select_main h-full overflow-hidden">
              <div className="select_placeholder sp_act">
                {workoutDesc && workoutDesc.length > 0 ? "Description (Max 250 Characters)" : "Enter Description..."}
              </div>
              <textarea value={workoutDesc} maxLength={250}
              className="h-full overflow-hidden"
                onChange={(e) => updateWorkoutsData("workout_desc", e.target.value)}/>
            </div>
          </div>
        </div>
      </div>
      <div className="eb_margin_set">
        
      
      {
        activityPool.length > 0 &&
        <div
          className={activityPool && activityPool.length > 0 ? "e_build_activities_hold" : ""}
          style={{ marginBottom: "140px", overflowX: 'auto' }}
        >
          {/* <div className="table_scrollable_container" style={{marginTop: "20px"}}>
        <div style={{ overflowX: 'scroll', width: '100%', height: "100%"}}> */}
  <div style={{overflowX: "auto", minWidth: "1100px",}}>
          {activityPool && activityPool.length > 0 && (
            <div className="e_build_single_act e_build_act_desc table_title_minwidth">
              <div className="eb_single_option eb_so_title eb_so_largest flex-1">Exercise Name</div>
              <div className="eb_single_option eb_so_title eb_so_mid eb_so_mid_smaller">Reps</div>
              <div className="eb_single_option eb_so_title eb_so_mid">Hold in seconds</div>
              <div className="eb_single_option eb_so_title eb_so_mid eb_so_mid_smaller">Max ROM</div>
                  <div className="eb_single_option eb_so_mid eb_so_mid_smaller opacity-0">
                      <div className="eb_select_contain">
                      </div>
                  </div>
                  <div className="eb_single_option opacity-0">
                    <div className="eb_select_contain">
                      <div
                        className={"eb_video_link"}
                      >
                        View Demo Video
                      </div>
                    </div>
                  </div>
              <div className="eb_single_option eb_so_last opacity-0">
                    <div className="add_btn eb_btn eb_arrow_up" >
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Reorder Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                    <div className="add_btn eb_btn eb_arrow_down" >
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Reorder Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                    <div className="add_btn eb_btn eb_info" >
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Duplicate Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                    <div className="add_btn eb_btn eb_close" >
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Delete Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                  </div>
            </div>
          )}
          <div className="eb_overall_activity w-full">
            {activityPool &&
              activityPool.length > 0 &&
              activityPool.map((item, i) => (
                <div key={i} className="e_build_single_act">
                  <div className="eb_single_option eb_so_largest flex-1">
                    <div
                      className="exr_coll_image_frame exr_image exr_image_frame_small"
                      style={{
                        backgroundImage: `url(${item.image})`,
                      }}
                    ></div>
                    <div className="exr_coll_title" title={item.display_name}>{item.display_name}</div>
                  </div>
                  <div
                    className={
                      "eb_single_option eb_so_mid eb_so_mid_smaller" +
                      (!item.display_name && errorInputs ? " prog_err_input" : "")
                    }
                  >
                    <div className="eb_select_contain">
                      <Select
                        initVal={item.reps ? item.reps : "Reps"}
                        selectOptions={optionsPlainNumsReps}
                        callBackValue={"reps"}
                        selectCallback={function (callVal, value) {
                          updateActDets([i, callVal], value);
                        }}
                        selectError={errorInputs && !item.reps}
                      />
                    </div>
                  </div>
                  <div className="eb_single_option eb_so_mid">
                    {eqIds.indexOf(item.equipment_id) === -1 && (
                      <div className="eb_select_contain">
                        <Select
                          initVal={item.hold_in_seconds > 0 ? item.hold_in_seconds : "No Hold"}
                          selectOptions={optionsPlainNums}
                          callBackValue={"hold_in_seconds"}
                          selectCallback={function (callVal, value) {
                            updateActDets([i, callVal], value);
                          }}
                          selectError={errorInputs && !item.hold_in_seconds}
                        />
                      </div>
                    )}
                  </div>
                  <div className="eb_single_option eb_so_mid eb_so_mid_smaller">
                    {item.have_rom === 1 && (
                      <div className="eb_select_contain">
                        <Select
                          initVal={item.target_rom_max ? item.target_rom_max : maxRom[0].value}
                          selectOptions={setMaxMinROM(item.rom_minimum)}
                          callBackValue={"target_rom_max"}
                          selectCallback={function (callVal, value) {
                            updateActDets([i, callVal], value);
                          }}
                          selectError={errorInputs && !item.target_rom_max}
                        />
                      </div>
                    )}
                  </div>
				  
				  
                  <div className="eb_single_option eb_so_mid eb_so_mid_smaller">
                    {!!item.limb_instructions === 1 && (
                      <div className="eb_select_contain">
                        <Select
                          initVal={item.set_limb_instruction ? item.set_limb_instruction.name : ''}
                          selectOptions={setLimb(item.limb_instructions)}
                          callBackValue={"set_limb_instruction"}
                          selectCallback={function (callVal, value) {
							let selectedOne = false;
							item.limb_instructions.forEach((itm) => { if ( itm.name == value ) { value = itm; }});
							updateActDets([i, callVal], value);
						  }}
                          selectError={errorInputs && !item.set_limb_instruction}
                        />
						  { !!item.set_limb_instruction && (
							<div style={{marginTop: "15px", textAlign: "center"}}><a href={item.set_limb_instruction.audio} target="_blank">Play Audio</a></div>
						  )}
                      </div>
                    )}
                  </div>
                  <div className="eb_single_option">
                    <div className="eb_select_contain">
                      <div
                        className={"eb_video_link" + (item.equipment_name ? "" : " e_l_disabled")}
                        onClick={() => openCloseVideo(item.video, item.equipment_name)}
                      >
                        View Demo Video
                      </div>
                    </div>
                  </div>
                  <div className="eb_single_option eb_so_last">
                    <div className="add_btn eb_btn eb_arrow_up" onClick={() => exrMove(i, -1)}>
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Reorder Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                    <div className="add_btn eb_btn eb_arrow_down" onClick={() => exrMove(i, 1)}>
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Reorder Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                    <div className="add_btn eb_btn eb_info" onClick={() => exrDuplicate(i)}>
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Duplicate Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                    <div className="add_btn eb_btn eb_close" onClick={() => openCloseDelete(i)}>
                      <div className="dbl_info_contain">
                        <div className="dbl_info">
                          <div className="dbl_info_text">Delete Exercise</div>
                        </div>
                        <div className="dbl_arrow"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          </div>
          
        {/* </div>
        </div> */}

        </div>
      }

        <div className="day_new_btn eb_new_tool" onClick={() => openUpExrCollection()}>
          <div className="dbl_info_contain">
            <div className="dbl_info">
              <div className="dbl_info_text">Add Exercise</div>
            </div>
            <div className="dbl_arrow"></div>
          </div>
        </div>
        {exrCollectionOpen && (
          <div
            className="dlt_wrapper"
            style={{
              height: exrPage.scrollHeight > window.innerHeight ? exrPage.scrollHeight + wrapMarg + "px" : 100 + "vh",
            }}
          >
            <div className="eb_exr_data_hold min_popup_size overflow-y-auto">
              <div className="eb_exr_titles_hold">
                <div className="eb_exr_popup_title">Add Exercises</div>
                <div className="eb_exr_popup_subtitle"></div>
              </div>
              <div className="eb_exr_search_hold">
                <input
                  type="text"
                  ref={searchExr}
                  placeholder="Search"
                  className="eb_exr_search"
                  onChange={() => updateCollectSearch(searchExr.current.value)}
                />
              </div>
              <div className="eb_exr_filter_hold">
                <div className="eb_single_filter">
                  <div className="eb_filter_title">Sub-Problem</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Flexion" },
                      { value: "Extension" },
                      { value: "Stenosis" },
                      { value: "Stabilization" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setSubProblemFilter}
                  />
                </div>
                <div className="eb_single_filter">
                  <div className="eb_filter_title">Exercise Type</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Strength" },
                      { value: "Stability" },
                      { value: "Mobility" },
                      { value: "Flexibility" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setTypeFilter}
                  />
                </div>
                <div className="eb_single_filter">
                  <div className="eb_filter_title">Exercise Difficulty</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Beginner" },
                      { value: "Intermediate" },
                      { value: "Advanced" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setDifficultyFilter}
                  />
                </div>
              </div>
              <div className="exr_card_container" ref={countChildren}>
                {exerciseCollection && exerciseCollection.length > 0 && shownChildren > 0 && (
                  <div className="exr_card_desc">
                    <div className="exr_card_txt_half">
                      <div className="exr_card_desc_txt">Select</div>
                      <div className="exr_card_desc_txt">Exercise Name</div>
                    </div>
                    <div style={{ textAlign: "right" }} className="exr_card_txt_half">
                      <div className="exr_card_desc_txt">View</div>
                      <div style={{ marginLeft: "140px" }} className="exr_card_desc_txt">
                        # of Sets
                      </div>
                    </div>
                  </div>
                )}
                {exerciseCollection &&
                  exerciseCollection.length > 0 &&
                  exerciseCollection.map((item, i) => (
                    <div
                      key={i}
                      className={
                        "exr_coll_card_expand" +
                        (subProblemFilter[0] !== "Show All" &&
                        subProblemFilter.indexOf(item.exercise_data.sub_problem_name) === -1
                          ? " exr_coll_hidden"
                          : typeFilter[0] !== "Show All" && typeFilter.indexOf(item.exercise_data.exercise_type) === -1
                          ? " exr_coll_hidden"
                          : difficultyFilter[0] !== "Show All" &&
                            difficultyFilter.indexOf(item.exercise_data.exercise_difficulty) === -1
                          ? " exr_coll_hidden"
                          : levelFilter[0] !== "Show All" &&
                            levelFilter.indexOf(item.exercise_data.exercise_level) === -1
                          ? " exr_coll_hidden"
                          : collectSearch.length > 0 &&
                            item.name.toLowerCase().indexOf(collectSearch.toLowerCase()) === -1
                          ? " exr_coll_hidden"
                          : "")
                      }
                    >
                      <div
                        className={
                          "exr_coll_card" +
                          (item.checked ? " exr_coll_card_selected" : "") +
                          " " +
                          (disablePortreit && item.is_portrait === 1 && !item.checked
                            ? " pst_last_disabled_no_op"
                            : disableLandscape && item.is_portrait === 0 && !item.checked
                            ? " pst_last_disabled_no_op"
                            : "")
                        }
                        onClick={() => handleExrSelection(i)}
                      >
                        <div className="exr_coll_half left_exr_coll">
                          <div className={"exr_coll_check" + (item.checked ? " exr_coll_checked" : "")}></div>
                          <div
                            className="exr_coll_image_frame exr_image"
                            style={{
                              backgroundImage: `url(${item.image})`,
                            }}
                          ></div>
                          <div className="exr_coll_title" title={item.name}>{item.name}</div>
                        </div>
                        <div style={{ marginRight: "12px" }} className="exr_coll_title">
                          {item.is_portrait === 0
                            ? "Floor Exercises"
                            : item.name.split(" ")[0] === "Seated"
                            ? "Sitting Exercises"
                            : "Standing Exercises"}
                        </div>
                        <div className="exr_coll_half right_exr_coll">
                          {item.checked && (
                            <div
                              className={"exr_coll_selector" + (!item.checked ? " exr_coll_select_disabled" : "")}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div
                                className={
                                  "exr_coll_change exr_coll_add" + (!item.checked ? " exr_coll_add_disabled" : "")
                                }
                                onClick={() => (item.checked ? addOrRemoveSets(i, "substract") : "")}
                              ></div>
                              {item.multiple_sets}
                              <div
                                className={
                                  "exr_coll_change exr_coll_substract" + (!item.checked ? " exr_coll_sub_disabled" : "")
                                }
                                onClick={() => (item.checked ? addOrRemoveSets(i, "add") : "")}
                              ></div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                {(exerciseCollection.length === 0 || shownChildren === 0) && (
                  <div className="exr_empty">No exercises found.</div>
                )}
              </div>
              <div className="exr_button_hold">
                <div className="exr_coll_button" onClick={() => addDismiss()}>
                  Cancel
                </div>
                <div
                  className={
                    "exr_coll_button exr_button_affirm" +
                    (exerciseCollection.filter((obj) => obj.checked === true).length === 0
                      ? " exr_affirm_disabled"
                      : "")
                  }
                  onClick={() =>
                    exerciseCollection.filter((obj) => obj.checked === true).length > 0 ? addDismiss(true) : ""
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
        {isOpenDelete && (
          <>
            <div className="dlt_wrapper">
              <div className="dbl_place_on_page">
                <Delete isActivity={true} dltDismiss={dltDismiss} />
              </div>
            </div>
          </>
        )}
        {isOpenVideo && (
          <div
            className="dlt_wrapper"
            style={{
              height: exrPage.scrollHeight > window.innerHeight ? exrPage.scrollHeight + wrapMarg + "px" : 100 + "vh",
            }}
          >
            <div className="vt_place_on_page">
              <VideoPlayer previewItem={previewItem} previewTitle={previewTitle} vtDismiss={openCloseVideo} />
            </div>
          </div>
        )}
        {/* {isExitOpen && (
          <div className="dlt_wrapper">
            <div className="dbl_place_on_page">
              <div className="exit_surround">
                <div className="exit_primary_title">Are you sure you want to exit?</div>
                <div className="exit_explain">
                  If you exit now your changes will be lost. Save your changes before exiting.
                </div>
                <div className="exit_btn_hold">
                  <div className="exit_btn exit_btn_bleak exit_new_btn_mid" onClick={() => handleExit()}>
                    Go back
                  </div>
                  <div
                    className="exit_btn exit_btn_bleak exit_new_btn_mid"
                    onClick={() =>
                      navigate(
                        task_id
                          ? "/details/" + sendBackParam + "/edit"
                          : "/" + (localStorage.getItem("prev_link") ? localStorage.getItem("prev_link") : "newprogram")
                      )
                    }
                  >
                    Exit
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}
        {errorPopUp && (
          <div className="prog_err_hold">
            <div className="prog_err_icon"></div>
            <div className="prog_err_text">{errorPopUp}</div>
          </div>
        )}
      </div>
        </>
      }
    </div>
  );
};

export default WorkoutDetails;
